var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMantaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.6 31.6",
    style: {
      enableBackground: "new 0 0 31.6 31.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#E8E8E8;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.8,
    cy: 15.8,
    r: 15.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.0075,
    y1: 17.5639,
    x2: 27.5509,
    y2: 17.9944,
    gradientTransform: "matrix(1 0 0 -1 0 33.5583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29CCB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#0091FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF66B7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,24.1c-2.5-1.9-4.2-4.9-4.2-8.3c0-5.7,4.6-10.3,10.3-10.3c4.7,0,9.9,2.8,11.1,7.1 c-1.4-4.8-5.8-8.4-11.1-8.4C9.4,4.2,4.2,9.4,4.2,15.8c0,6.4,5.2,11.6,11.6,11.6c6.4,0,11.6-5.2,11.6-11.6v-0.6h-0.6c0,0,0,0-0.1,0 c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.9-0.2-2.5-0.5c-1.1-0.4-1.7-1-2.4-1.7l0,0c-0.7-0.7-1.5-1.4-2.9-2.1 c-1.3-0.6-2.8-0.5-3.9-0.3c-0.6,0.1-1,0.3-1.4,0.4C12,11,11.8,11,11.7,11c-0.5,0.2-1.1,0.5-1.6,0.8c0,0,1.1,0.3,1.6,0.5 c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.6,0.3,1,0.5c0.6,0.4,1,0.8,1.2,1.4c-1.2,0.2-2.3,0.7-3.2,1.2 c-0.5,0.3-0.9,0.6-1.2,0.8c-0.1,0.1-0.3,0.2-0.3,0.3c-0.1,0.1-1.2,1-1.2,1s1.4,0.1,2.1,0.3c0.5,0.1,1.1,0.2,1.7,0.5 c0.6,0.2,1.3,0.5,1.8,0.9c0.5,0.4,0.9,0.8,1.1,1.3c0.6,1.5,0,2.9-1.1,3.7C13,25,11.3,25.2,9.6,24.1L9.6,24.1z M13.5,25.9 c0.5-0.1,0.9-0.4,1.3-0.6c1.5-1.1,2.3-3.1,1.5-5.1c-0.3-0.8-0.9-1.4-1.6-1.9c-0.7-0.5-1.4-0.8-2.1-1.1c-0.5-0.2-0.9-0.3-1.3-0.4 c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,2.1-1.1,3.2-1.1c1.7,0,3,0.5,4.2,1.1c0.1,0.1,0.2,0.1,0.3,0.2c1.1,0.5,2.2,1,3.5,1 c1.3,0,2.3-0.4,3-0.7c-0.6,5.1-5,9.1-10.3,9.1C15,26.1,14.3,26,13.5,25.9L13.5,25.9z M24.7,16.3c-0.5,0.2-1,0.3-1.7,0.3 c-1,0-1.9-0.4-3.1-0.9c-0.1,0-0.2-0.1-0.3-0.1c-1.1-0.5-2.4-1.1-4.2-1.2c-0.2-1.1-1.1-1.9-1.8-2.4c-0.1-0.1-0.2-0.1-0.2-0.2 c0.1,0,0.1,0,0.2-0.1c1-0.2,2.2-0.3,3.2,0.2c1.2,0.6,1.9,1.2,2.5,1.9l0,0c0.7,0.7,1.5,1.4,2.8,1.9C23,16,23.9,16.2,24.7,16.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMantaIcon);
export default __webpack_public_path__ + "static/media/manta_icon.1e96bfd4cae65814c6c60b516570dbc7.svg";
export { ForwardRef as ReactComponent };